const config = {
  basename: '/',
  defaultPath: '/',
  fontFamily: `'Open Sans', sans-serif;`,
  borderRadius: 12
};

export default config;
